// import moment from "moment";

import moment from "moment-timezone/builds/moment-timezone-with-data";

function formatFromUtcAs(date, format) {
  var timeZoneID = localStorage.getItem("timeZoneID");

  if (!timeZoneID) return '';
  if (!date || date === "Invalid date") return '';

  return moment.utc(date).tz(timeZoneID).format(format);
}

function formatAs(date, format) {
  var timeZoneID = localStorage.getItem("timeZoneID");

  if (!timeZoneID) return '';
  if (!date || date === "Invalid date") return '';

  return moment(date).tz(timeZoneID).format(format);
}

export const utcToLocal = (date) => formatFromUtcAs(date, "YYYY-MM-DD hh:mm:ss a");

export const utcToDate = (date) => formatFromUtcAs(date, "MMMM Do hh:mm:ss a");

// All functions are prefixed with utc but ONLY the first two actually expect UTC...
// Don't blindly follow naming conventions without understanding what the hell they're trying to communicate
export const utcToReport = (date) => formatAs(date, "DD-MMM hh:mm:ss a");

export const utcToReport24 = (date) => formatAs(date, "DD-MMM HH:mm:ss");

export const utcToDDMMYYYY = (date) => formatAs(date, "DD-MM-YYYY");

export const utcToReportDate = (date) => formatAs(date, "DD-MM-YY HH:mm:ss");

export const utcToHomeDate = (date) => formatAs(date, "DD-MM-YYYY HH:mm:ss");

export const utcToLocalDate = (date) => formatFromUtcAs(date, "MMMM Do YYYY HH:mm:ss");

export const getTimeSpanToNow = (created) => {
  if (!created) return null;

  let currentDate = new Date();
  let statusDate = new Date(created);
  let diffDate = currentDate - statusDate;

  let h = Math.floor(diffDate / 1000 / 60 / 60);
  let m = Math.floor((diffDate / 1000 / 60 / 60 - h) * 60);
  let s = Math.floor(((diffDate / 1000 / 60 / 60 - h) * 60 - m) * 60);

  return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
}

export const dayToHour = (value) => {
  if (!value) return null;

  let dayHourTotal = value.split(":");
  let dayHour = dayHourTotal[0].split(".");
  let totalHour;
  if (dayHour.length > 1) {
    let day = parseInt(dayHour[0]) * 24;
    totalHour = day + parseInt(dayHour[1]);
  } else {
    totalHour = dayHour;
  }

  let dayHourTotalSplit = dayHourTotal[2].split(".");

  return `${totalHour}:${dayHourTotal[1]}:${dayHourTotalSplit[0]}`;
};

export const utcToAssetLogReportDateTime = (date, timeZoneID) => {
  if (!timeZoneID) return '';
  if (!date || date === "Invalid date") return '';

  return moment(date).tz(timeZoneID).format("DD-MM-YYYY HH:mm:ss");
};